import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { DataServiceService } from 'src/app/services/data-service.service';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports:[RouterModule]
})
export class AboutComponent implements OnInit {

  title = "About Investing for Catholics.";
  

  constructor(private dataservice: DataServiceService, private seoservice: SeoService, private meta: Meta) { 

  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'about investing for catholics, investing for catholics advisors, investing for catholics management'});
    this.meta.addTag({name: 'description', content: 'Learn how Investing for Catholics was formed and about its advisors and management staff.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
